import { Component, Input } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { NavigationHistoryService } from '../../services/navigation-history.service';

@Component({
  selector: 'app-back-button',
  templateUrl: './back-button.component.html',
  styleUrls: ['./back-button.component.scss'],
})
export class BackButtonComponent {
  @Input() pageTitle: string = '';

  constructor(
    private location: Location,
    private router: Router,
    private navigationHistoryService: NavigationHistoryService
  ) {}

  get isVisible(): boolean {
    const url = this.router.url.split('?')[0].split('#')[0];
    return url !== '/home' && url !== '/login';
  }

  goBack(): void {
    if (this.navigationHistoryService.hasHistory()) {
      this.location.back();
    } else {
      this.router.navigate(['/home']);
    }
  }
}
